import GroupDetails from '@/src/components/campaigns/CampaignSections/Groups/GroupDetails';
import { Campaign } from '@/src/types/Campaign';
import React from 'react';

export const CampaignGroupDetailsPage: React.FC = () => {
  // todo get campaign details
  return <GroupDetails campaign={{} as Campaign} />;
};
